import { initBotId } from "botid/client/core";

// BotID attaches its challenge headers to requests to the paths below.
initBotId({ protect: [{ path: "/api/generate", method: "POST" }] });
